export const API_V1_AUTH = "/api/v1/auth";
export const API_V1_AUTH_LOGIN = API_V1_AUTH + "/login";
export const API_V1_AUTH_LOGIN_RENEW = API_V1_AUTH + "/login/renew";
export const API_V1_AUTH_LOGOUT = API_V1_AUTH + "/logout";

export const API_V1_CHATS = "/api/v1/chats";

export const API_V1_CREDIT_REQUESTS = "/api/v1/credits";
export const API_V1_CREDIT_ATTACHMENTS = "/api/v1/credit-attachments";
export const API_V1_CREDIT_ATTACHMENT_TYPES = "/api/v1/credit-attachment-types";
export const API_V1_CREDIT_PAYMENTS = "/api/v1/credit-payments";
export const API_V1_CREDIT_LINKS = "/api/v1/credit-links";

export const API_V1_BANK_CREDIT_REQUESTS = "/api/v1/bank-credits";

export const API_V1_CARD = "/api/v1/cards";
export const API_V1_CARD_LINKS = "/api/v1/card-links";

export const API_V1_ME = "/api/v1/me";

export const API_V1_PROFILES = "/api/v1/profiles";

export const API_V1_USERS = "/api/v1/users";
export const API_V1_USER_COMMENTS = "/api/v1/user-comments";
export const API_V1_USER_RECOMMENDATIONS = "/api/v1/user-recommendations";

export const API_V1_CONTROL = "/api/v1/control";

export const API_V1_TODO = "/api/v1/todo";

export const API_V1_ABSENCE = "/api/v1/absence";
export const API_V1_HOLIDAY = "/api/v1/holiday";

export const API_V1_QUICK_CHECK = "/api/v1/quick-check";

export const API_V1_BANK_SPECIFIC = "/api/v1/bank-specific";
export const API_V1_BANK_COMMENTS = "/api/v1/bank-comments";
export const API_V1_BANK_CREDIT_NOTES = "/api/v1/bank-credit-note";
export const API_V1_BANK_ATTACHMENTS = "/api/v1/bank-attachments";

export const EXCEPTION_IDENTITY_NOT_FOUND = "IDENTITY_NOT_FOUND";

export const PROFILE_AGENT_ID = 2;
export const PROFILE_ADMIN_ID = 1;
